'use strict';

const Help = {
    'codigoProducto': 'Identificador del producto en Mercado Virtual',
    'codigoUnspsc': 'Código de Catálogo UNSPSC',
    'codigoFicha': 'Código de la ficha',
    'codigoNandina': 'Código NANDINA',
    'nombreProducto': 'Nombre del producto',
    'capacidadProduccionMensual': 'Capacidad de Producción Mensual',
    'precioUnitario': 'Precio por unidad',
    'posicionArancelaria': 'Posicion arancelaria',
    'color': 'Se aplica a productos que pueden ser caracterizados por color. Ejemplo: prendas de vestir.',
    'talla': 'Se aplica a productos que se fabrican por tallas. Ejemplo: textiles, prendas de vestir.',
    'peso': 'Se aplica a productos cuantificables en Kilogramos, litros, etc. Por ejemplo: productos alimenticios.',
    'medidas': 'Se aplica a productos, cuyas dimensiones (alto, ancho, fondo) pueden medirse. Por ejemplo: 30 cm x 25 cm x  3 cm.',
    'marca': 'Este campo es obligatorio si es que a futuro solicitará certificado Hecho en Bolivia para el producto',
    'nombre_comercial': 'Registre un nombre descriptivo que permita identificar de forma clara al producto. Ejemplo: Silla unipersonal de melamina y estructura metálica'
};

export default Help;



// WEBPACK FOOTER //
// ./src/app/common/lang/es/help.lang.js